import { ChannelBox, ChannelLogo } from "planby";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { getSelectedChannel } from "../../../Redux/SelectedChannel/selectedChannelSlice";
import { getSelectedSchedule } from "../../../Redux/SelectedScheduleChannel/selectedScheduleChannelSlice";

export const ChannelItem = ({ channel }) => {
  const { position, logo, uuid, title } = channel;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const selectedChannelData = useSelector((state) => state?.selectedChannel?.value);

  const queryParams = new URLSearchParams(location.search);
  const activeChannelId = queryParams.get('c') || selectedChannelData?.selectedChannel?.channel_id || selectedChannelData?.channel_id;

  const isSelected = activeChannelId && (activeChannelId?.toString() === uuid?.toString());

  const selectedChannelHandler = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    dispatch(
      getSelectedChannel({
        selectedChannel: { channel_id: uuid }
      })
    )
    dispatch(
      getSelectedSchedule({
        selectedSchedule: { channel_id: uuid }
      })
    )
    navigate("/live-channels?c=" + uuid, { state: { channel_id: uuid, homelive: true } });
  }

  return (
    <ChannelBox
      {...position}
      onClick={() => selectedChannelHandler()}
      className={isSelected ? "epg-channel-box selected-epg-channel" : "epg-channel-box"}
      data-channel-id={uuid}
      style={{
        ...position,
        ...(isSelected ? { backgroundColor: 'var(--epg-primary-color, #121212)', borderLeft: '4px solid #ffffff' } : {})
      }}
    >
      <div data-channel-id={uuid} onClick={() => selectedChannelHandler()} style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <ChannelLogo
          src={logo ? logo : projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE}
          alt="Logo"
          title={title}
          style={{
            maxHeight: 52,
            maxWidth: 52,
            cursor: 'pointer',
            ...(isSelected ? { border: '2px solid #ffffff', borderRadius: '8px', padding: '2px' } : {})
          }}
        />
      </div>
    </ChannelBox>
  );
};
